export default __webpack_public_path__ + "static/media/menu-baterai.1069e2a5.svg";